/* eslint-disable */

import SignupForm from "Signup/SignupForm.vue"
import useAnalyticsLoader from "services/useAnalyticsLoader.js"

document.getElementById("signup-form") && new Vue({
    name: "ButterCMSSignup",
    el: "#signup-form",
    render: h => h(SignupForm),
})

const {
    loadAnalyticsDataset
} = useAnalyticsLoader()

loadAnalyticsDataset()
